module.exports = __webpack_public_path__ + "img/VENCIDO.0fe71969.png";